export const LocationIcon: React.FC = () => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15 12.5C15 13.8261 15.5268 15.0979 16.4645 16.0355C17.4021 16.9732 18.6739 17.5 20 17.5C21.3261 17.5 22.5979 16.9732 23.5355 16.0355C24.4732 15.0979 25 13.8261 25 12.5C25 11.1739 24.4732 9.90215 23.5355 8.96447C22.5979 8.02678 21.3261 7.5 20 7.5C18.6739 7.5 17.4021 8.02678 16.4645 8.96447C15.5268 9.90215 15 11.1739 15 12.5V12.5Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 1.25C22.9837 1.25 25.8452 2.43526 27.9549 4.54505C30.0647 6.65483 31.25 9.51631 31.25 12.5C31.25 17.9183 22.6967 30.045 20.5067 33.0617C20.4483 33.1412 20.372 33.2059 20.284 33.2505C20.196 33.2952 20.0987 33.3184 20 33.3184C19.9013 33.3184 19.804 33.2952 19.716 33.2505C19.628 33.2059 19.5517 33.1412 19.4933 33.0617C17.3033 30.045 8.75 17.9183 8.75 12.5C8.75 9.51631 9.93526 6.65483 12.045 4.54505C14.1548 2.43526 17.0163 1.25 20 1.25V1.25Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M29.965 29.6406C34.5183 30.5423 37.5 32.0473 37.5 33.7506C37.5 36.5123 29.6667 38.7506 20 38.7506C10.3333 38.7506 2.5 36.5123 2.5 33.7506C2.5 32.0506 5.46833 30.549 10 29.6456'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
